import { Map } from "mapbox-gl";

export function fadeCircles(
  map: Map,
  layer: string,
  value: number,
  duration = 500
): void {
  const fillAttribute = "circle-opacity";
  const strokeAttribute = "circle-stroke-opacity";

  // @ts-ignore
  map.setPaintProperty(layer, `${fillAttribute}-transition`, {
    duration
  });

  map.setPaintProperty(layer, `${strokeAttribute}-transition`, {
    duration
  });

  // @ts-ignore
  map.setPaintProperty(layer, fillAttribute, value);
  map.setPaintProperty(layer, strokeAttribute, value);
}

export function fadeText(
  map: Map,
  layer: string,
  value: number,
  duration = 500
): void {
  const attribute = "text-opacity";
  // @ts-ignore
  map.setPaintProperty(layer, `${attribute}-transition`, {
    duration
  });

  // @ts-ignore
  map.setPaintProperty(layer, attribute, value);
}

export function fadeLine(
  map: Map,
  layer: string,
  value: number,
  duration = 500
): void {
  const attribute = "line-opacity";
  // @ts-ignore
  map.setPaintProperty(layer, `${attribute}-transition`, {
    duration
  });

  // @ts-ignore
  map.setPaintProperty(layer, attribute, value);
}

export function fadeFill(
  map: Map,
  layer: string,
  value: number,
  duration = 500
): void {
  const attribute = "fill-opacity";
  // @ts-ignore
  map.setPaintProperty(layer, `${attribute}-transition`, {
    duration
  });

  // @ts-ignore
  map.setPaintProperty(layer, attribute, value);
}

export function paintSymbol(
  map: Map,
  layer: string,
  attribute: string,
  value: string | number
): void {
  if (map.getLayer(layer)) {
    // @ts-ignore
    map.setPaintProperty(layer, attribute, value);
  }
}

export function fadeLocator(locator: HTMLDivElement, value: number): void {
  locator.style.opacity = `${value}`;
}
